import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { alertError } from "../../../../utils/logger";
import { Col, Row } from "react-bootstrap";
import { formattedValueNumber } from "../../../../utils/numbers";
import OnlyDate from "../../textFields/OnlyDate";
import { formatDateForInput } from "../../../../utils/helpers";

function getEmptyWeight(patientId) {
    const today = formatDateForInput(new Date());
    // const date = new Date(today.getTime() - today.getTimezoneOffset() * 60000).toISOString().split('.')[0];
    return {
        userId: patientId,
        date: today,
        weight: null,
        active: true
    }
}

export default function EditBodyWeight(props)  {
    const { open, setOpen, data, onSave, patientId } = props;
    const [bodyWeight, setBodyWeight] = useState(null);

    useEffect(() => {
        if (data) {
			const date = formatDateForInput(new Date(data?.date));
			// const date = new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().split('.')[0];
            setBodyWeight({...data, date: date});
        }
        else setBodyWeight(getEmptyWeight(patientId))
    }, [data, open])

    const handleChange = (element) => (event) => {
        const { value } = event.target;
        const formattedValue = formattedValueNumber(value, true);
        setBodyWeight({...bodyWeight, [element]: formattedValue});
    }

    function close() {
        setOpen(false);
        setBodyWeight(null);
    }

    return (
        <Dialog disableBackdropClick={true} 
            fullWidth={true}
            open={open}
            onClose={() => setOpen(false)}
            maxWidth="lg"
            aria-labelledby="table-dialog"
        >
            <DialogTitle id="table-dialog">{"Body weight"}</DialogTitle>
			<DialogContent>
                <Row>
                    <Col>
                    <OnlyDate title={"Date"} element={"date"} handleChange={handleChange} data={bodyWeight} specific={false}/>
                    </Col>
                    <Col>
						<TextField
							id={"weight"}
							label={"Weight (kg)"}
							value={(bodyWeight?.weight)}
							onChange={handleChange('weight')}
							InputLabelProps={{shrink: true}}
							margin="normal"
							variant="standard"
							type="number"
							InputProps={{
								inputProps: {
									min: 0
								}
							}}
						/>
                    </Col>
                </Row>
				<br /> <br /> <br /> <br /> <br /><br />
				<br /> <br /> <br /> <br /> <br /><br />
            </DialogContent>
            <DialogActions>
				<Button
					variant="outlined"
					style={{ marginRight: "15px" }}
					onClick={() => {
						close();
					}}
				>
					Close
				</Button>
				<Button
					variant="outlined"
					color="primary"
					onClick={async () => {
                        if (!bodyWeight?.weight) {
                            alertError({
                                error: null,
                                customMessage: "Weight is required"
                            })
                        }
                        else {
                            const res = await onSave(bodyWeight);
                            if (res) close();
                        }
					}}
				>
					Save
				</Button>
			</DialogActions>
        </Dialog>
    )
}